import React, { useMemo, memo } from 'react';

function ProgressBar(props) {
  const { progress, style = undefined } = props;
  const [redPercent, yellowPercent] = [40, 70];
  const [color, width] = useMemo(() => {
    let value = Math.max(0, Math.min(100, progress));
    let color;
    if (value <= redPercent) {
      color = 'red';
    } else if (value > redPercent && value <= yellowPercent) {
      color = '#F3E400';
    } else if (value > yellowPercent) {
      color = '#21D700'; // Verde
    }
    return [color, value];
  }, [progress]);

  return (
    <div
      style={{
        width: '100%',
        borderRadius: '50px',
        backgroundColor: 'white',
        border: '1px solid black',
        height: '30px',
        position: 'relative',
      }}
    >
      <div
        style={{
          width: `${width}%`,
          backgroundColor: color,
          height: '100%',
          borderRadius: '50px',
        }}
      ></div>

      <span
        style={{
          width: '100%',
          textAlign: 'center',
          position: 'absolute',
          top: 4,
        }}
      >
        {progress}%
      </span>
    </div>
  );
}

export default memo(ProgressBar);
